import useEffectiveWorkflowRunFilters from '@UI/Pages/WorkflowRuns/Hooks/useEffectiveWorkflowRunFilters';
import workflowRunFiltersSignal, {
	setWorkflowRunFilters,
} from '@UI/Pages/WorkflowRuns/Filters/Signals/workflowRunFiltersSignal';
import formFieldStylesPt from '@UI/Pages/WorkflowRuns/Filters/Helpers/formFieldStylesPt';
import * as React from 'react';
import type FacilityUserView from '@UI/Store/FacilityUsers/Views/FacilityUserView';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly options: readonly FacilityUserView[];
};

const AssignedUserFilter: React.FC<Props> = ({ options }) => {
	const filters = useEffectiveWorkflowRunFilters();

	const handleAssignedUserChange = React.useCallback((assignedUserId: number | null) => {
		setWorkflowRunFilters(workflowRunFiltersSignal.peek().setAssignedUserId(assignedUserId));
	}, []);

	return (
		<Dropdown<number>
			name="workflowRunAssignedUser"
			label="Référent"
			placeholder="Tous les référents"
			options={[...options]}
			optionLabel="fullName"
			optionValue="id"
			showClear
			value={filters.assignedUserId}
			onChange={handleAssignedUserChange}
			pt={formFieldStylesPt}
		/>
	);
};

export default AssignedUserFilter;
